import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/inherits";
import { HachureFiller } from './hachure-filler';
export var HatchFiller =
/*#__PURE__*/
function (_HachureFiller) {
  _inherits(HatchFiller, _HachureFiller);

  function HatchFiller() {
    _classCallCheck(this, HatchFiller);

    return _possibleConstructorReturn(this, _getPrototypeOf(HatchFiller).apply(this, arguments));
  }

  _createClass(HatchFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      var set = this._fillPolygon(points, o);

      var o2 = Object.assign({}, o, {
        hachureAngle: o.hachureAngle + 90
      });

      var set2 = this._fillPolygon(points, o2);

      set.ops = set.ops.concat(set2.ops);
      return set;
    }
  }, {
    key: "fillEllipse",
    value: function fillEllipse(cx, cy, width, height, o) {
      var set = this._fillEllipse(cx, cy, width, height, o);

      var o2 = Object.assign({}, o, {
        hachureAngle: o.hachureAngle + 90
      });

      var set2 = this._fillEllipse(cx, cy, width, height, o2);

      set.ops = set.ops.concat(set2.ops);
      return set;
    }
  }]);

  return HatchFiller;
}(HachureFiller);